import React from 'react';
import { Prompt } from './Prompt.component';

export const ExaminerBlocked: React.FC<{ isAssessmentsView: boolean; onClose(): void }> = (props) => {
  return (
    <Prompt
      open={true}
      type="warning"
      mainText={'Możliwość pobierania nowych RGZ do oceny została zablokowana.'}
      mainActionButtonText={props.isAssessmentsView ? 'Powrót do listy' : 'Powrót'}
      onConfirm={props.onClose}
    />
  );
};
